(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-progress-bar"] && !Shopify.designMode) return;
  try {
    
class DiscountProgressBar extends HTMLElement {
  static get observedAttributes() {
    return ['eligible-total']
  }

  connectedCallback() {
    this.abortController = new AbortController()
    const { signal } = this.abortController

    document.addEventListener('cart:change', () => this.refresh(), { signal })
    document.addEventListener('cart:refresh', () => this.refresh(), { signal })

    this.render()
  }

  disconnectedCallback() {
    this.abortController?.abort()
    this.fetchController?.abort()
  }

  attributeChangedCallback() {
    if (this.isConnected) this.render()
  }

  get eligibleTotal() {
    return parseFloat(this.getAttribute('eligible-total')) || 0
  }

  // Tier thresholds are stored in the shop's default currency (cents), convert them to the presentment currency
  get tiers() {
    const rate = parseFloat(window.Shopify?.currency?.rate) || 1

    return Array.from(this.querySelectorAll('.discount-progress-bar__tier'))
      .map((element) => ({
        element,
        threshold: Math.round(parseFloat(element.dataset.threshold) * rate),
        label: element.dataset.label
      }))
      .sort((a, b) => a.threshold - b.threshold)
  }

  async refresh() {
    this.fetchController?.abort()
    this.fetchController = new AbortController()

    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=${encodeURIComponent(this.getAttribute('section-id'))}`,
        { signal: this.fetchController.signal }
      )
      const html = await response.text()
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('discount-progress-bar')

      if (fresh) this.setAttribute('eligible-total', fresh.getAttribute('eligible-total'))
    } catch (error) {
      // Aborted by a newer cart change, or a network error — keep the current state
    }
  }

  render() {
    const tiers = this.tiers
    if (tiers.length === 0) return

    const total = this.eligibleTotal
    const reachedCount = tiers.filter((tier) => total >= tier.threshold).length
    const nextTier = tiers[reachedCount]

    tiers.forEach((tier, index) => {
      tier.element.classList.toggle('discount-progress-bar__tier--reached', index < reachedCount)
    })

    const message = this.querySelector('.discount-progress-bar__message')

    if (nextTier) {
      message.textContent = this.getAttribute('progress-message')
        .replace(/\[amount\]/g, this.formatMoney(nextTier.threshold - total))
        .replace(/\[discount\]/g, nextTier.label)
    } else {
      message.textContent = this.getAttribute('complete-message').replace(/\[discount\]/g, tiers[tiers.length - 1].label)
    }

    const percent = this.fillPercent(tiers, total, reachedCount)
    this.querySelector('.discount-progress-bar__fill').style.width = `${percent}%`
    this.querySelector('.discount-progress-bar__track').setAttribute('aria-valuenow', Math.round(percent))
    this.classList.toggle('discount-progress-bar--complete', !nextTier)
  }

  // Tier dots are evenly spaced along the track (first at 0%, last at 100%), so the fill moves proportionally within
  // the segment between the last reached tier and the next one.
  fillPercent(tiers, total, reachedCount) {
    if (reachedCount === 0) return 0
    if (reachedCount === tiers.length || tiers.length === 1) return 100

    const segment = 100 / (tiers.length - 1)
    const from = tiers[reachedCount - 1].threshold
    const to = tiers[reachedCount].threshold
    const progressInSegment = to > from ? (total - from) / (to - from) : 0

    return (reachedCount - 1 + progressInSegment) * segment
  }

  formatMoney(cents) {
    const amount = cents / 100

    return new Intl.NumberFormat(window.Shopify?.locale, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2
    }).format(amount)
  }
}

if (!window.customElements.get('discount-progress-bar')) {
  window.customElements.define('discount-progress-bar', DiscountProgressBar)
}

  } catch(e) { console.error(e); }
})();
})();
